import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { CallServiceAbstract } from "../call.service";
import { SettingsService } from "../../settings.service";
import { AuthenticationService } from "../../auth/Authentication/authentication.service";
import { Subject } from 'rxjs';
import { NotificationService } from '../../notification.service';
import { StateService } from '../../state/state.service';

@Injectable({
    providedIn: 'root'
  })

export class GeneralCustomProperties extends CallServiceAbstract {
    constructor(
        http: HttpClient,
        settings: SettingsService,
        authentication: AuthenticationService,
        notify: NotificationService,
        state: StateService,
        ) {
        super(http, settings, authentication, notify, state, 'Systems_Bpm_CustomProperties', 'Потребителски характеристики');
        }


    filter(filter) {
        let obz = new Subject();
        this.query(filter).subscribe(
            data => obz.next(data),
            err => obz.error(err)
        );
        return obz.asObservable();
    }

    public findRefDoc() {
        let call = JSON.parse(JSON.stringify(this.stateTemplate));
        call.filter.filters.push({ field: 'EntityName', operator: 'eq', value: "'Gen_Documents'" });
        call.filter.filters.push({ field: 'Code', operator: 'eq', value: "'ref_doc'" });
        return this.filter(call)
    }
}